import React from 'react';
import { Form, Input } from 'antd';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
}) => {
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        { required: true, message: `Por favor ingresa ${title}` },
                        {
                            min: 3,
                            max: 100,
                            message: 'La habilidad debe tener entre 3 y 100 caracteres',
                        },
                        {
                            whitespace: true
                        }
                    ]}
                >
                    <Input placeholder='Ingresa una habilidad' />
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export default EditableCell;